import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import ElearningCard from "./ElearningCard";

const Section = styled.section`
  padding: 96px 0;
  background: var(--nd-black);
  @media (max-width: 768px) { padding: 64px 0; }
`;

const Kicker = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin: 0 0 16px;
`;

const Heading = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 48px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 16px;
  @media (max-width: 768px) { font-size: 32px; }
`;

const Sub = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 48px;
  max-width: 640px;
`;

const ColWrap = styled(Col)`
  margin-bottom: 24px;
  display: flex;
`;

const ElearningGrid = ({ modules, instructions }) => (
  <Section>
    <Container>
      <Kicker>E-LEARNING</Kicker>
      <Heading>Courses you can finish</Heading>
      <Sub>
        Short, dense, opinionated. Each course has a free preview lesson and
        an AI mentor that knows the curriculum. Sign in to track progress.
      </Sub>
      {instructions}
      <Row>
        {modules.map((m) => (
          <ColWrap xs="12" sm="6" lg="4" key={m.id}>
            <ElearningCard module={m} />
          </ColWrap>
        ))}
      </Row>
    </Container>
  </Section>
);

export default ElearningGrid;
